/** Route segment for this view. */
const PATH = 'factory-arm';

/** Root of every class and custom property this view owns. */
const CLASS_NAME = 'kicl--views--experiments--factory-arm';

/** The setup panel's id, for the buttons that open and close it on small screens. */
const PANEL = `${CLASS_NAME}--panel`;

export { CLASS_NAME, PANEL, PATH };
